import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, IconButton, Typography } from '@mui/material';
import { CallEndIcon, PhoneIcon } from '@sharedCR/coreDesignSystem/icons';

import { answerCallAction, hangupCallAction } from 'store/system/actions';
import { selectCallState } from 'store/system/selectors';

import {
  answerButtonStyles,
  buttonRowStyles,
  callerInfoStyles,
  callerNameStyles,
  callerNumberStyles,
  containerStyles,
  declineButtonStyles,
} from './IncomingCall.styles';
import { IncomingCallTestIds } from './IncomingCall.testIds';

const IncomingCall = () => {
  const dispatch = useDispatch();
  const callState = useSelector(selectCallState);

  const onAnswer = useCallback(() => {
    dispatch(answerCallAction());
  }, [dispatch]);

  const onDecline = useCallback(() => {
    dispatch(hangupCallAction());
  }, [dispatch]);

  const displayName = callState.callerName || 'Unknown Caller';
  const displayNumber = callState.callerNumber || '';

  return (
    <Box sx={containerStyles}>
      <Box sx={callerInfoStyles}>
        <Typography sx={callerNameStyles} variant="bold20">
          {displayName}
        </Typography>
        {displayNumber && (
          <Typography sx={callerNumberStyles} variant="regular14">
            {displayNumber}
          </Typography>
        )}
        <Typography sx={callerNumberStyles} variant="regular14">
          Incoming Call...
        </Typography>
      </Box>

      <Box sx={buttonRowStyles}>
        <IconButton
          aria-label="Decline"
          data-testid={IncomingCallTestIds.DECLINE}
          sx={declineButtonStyles}
          onClick={onDecline}
        >
          <CallEndIcon />
        </IconButton>
        <IconButton
          aria-label="Answer"
          data-testid={IncomingCallTestIds.ANSWER}
          sx={answerButtonStyles}
          onClick={onAnswer}
        >
          <PhoneIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default memo(IncomingCall);
